import { createHashHistory, createRouter } from "@tanstack/react-router";

import { foundationRoutes } from "../app/pages/routes";
import { designSystemRoute } from "../design-system/routes";
import { RouteErrorState, RoutePendingState } from "../design-system/RouteStates";
import { authRoute } from "../features/auth/routes";
import { calendarRoutes } from "../features/calendar/routes";
import { catalogRoutes } from "../features/catalog/routes";
import { libraryRoutes } from "../features/library/routes";
import { profileRoutes } from "../features/profile/routes";
import { appLayoutRoute, rootRoute } from "./rootRoutes";

const appRoutes = [
  ...foundationRoutes,
  ...calendarRoutes,
  ...catalogRoutes,
  ...libraryRoutes,
  ...profileRoutes,
] as const;

const routeTree = rootRoute.addChildren([
  authRoute,
  appLayoutRoute.addChildren(import.meta.env.DEV ? [...appRoutes, designSystemRoute] : appRoutes),
]);

export function createAppRouter() {
  return createRouter({
    routeTree,
    history: createHashHistory(),
    defaultPreload: "intent",
    defaultPreloadStaleTime: 30_000,
    defaultPendingComponent: RoutePendingState,
    defaultPendingMs: 160,
    defaultPendingMinMs: 160,
    defaultErrorComponent: RouteErrorState,
    scrollRestoration: true,
  });
}

export const router = createAppRouter();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
